<template>
  <div v-if="loaded">
    <hero-header centered heading="Regulatory Appropriatness Test" />
    <div class="row justify-content-center my-5">
      <div class="col-md-8">
        <form @submit.prevent="submit">
          <p>
            We want to ensure that all our co-funding investors fully understand the investments that
            they are making and the risks (and potential rewards) that are on offer.
            As such, we conduct a regulatory appropriateness test on all new members so we can learn more
            about your experience and your attitude to risk.  We treat all information in strictest
            confidence and by answering the questions you are helping us to meet our regulatory requirements.
            Completing the test should only take around 5 minutes (but could take longer depending on your
            own responses and considerations).
          </p>
          <div class="row mt-4">
            <div class="col-12 col-sm-6">
              <base-button exact :to="{ name: 'dashboard' }">Come back later</base-button>
            </div>
            <div class="col-12 col-sm-6 text-right">
              <base-button icon-right="arrow-right" :loading="saving" primary submit>
                Lets get started
              </base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-else>
    <base-loader />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  mounted () {
    this.loaded = true
  },

  data: () => ({
    loaded: false,
    saving: false
  }),

  components: {
    HeroHeader
  },

  computed: {
    ...mapGetters({
      schema: 'core/user-appropriateness/schema'
    }),

    ...mapState({
      appropriateness: store => store.core.userAppropriateness.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true

      if (!this.$auth.user.appropriateness) {
        const appropriateness = this.schema
        appropriateness.user = this.$auth.user._id

        await this.$store.dispatch('core/user-appropriateness/save', appropriateness)
        await this.$store.dispatch('core/auth/patch', { appropriateness: this.appropriateness._id })
      }

      this.$router.push({ name: 'appropriateness.experience' })
    }
  }
}
</script>
